// extracted by mini-css-extract-plugin
export default {"title":"Header_title__yu-5v"};